import { TCheckinHistory, CheckinSummary } from '@/types/api';

export const formatCheckinHistory = (checkins: CheckinSummary[]): TCheckinHistory[] => {
  return checkins.map((checkin) => ({
    endDate: checkin.dueDate,
    isPending: !checkin.answeredAt,
    submittedDate: checkin.answeredAt,
    checkinId: checkin.id,
  }));
};

export const defaultCheckinDateFormat = 'MMM dd, yyyy';
export const dateWithHours = 'MMM dd p';
export const fullDateWithHours = 'MMM dd yyyy p';
